var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTxDotsExtra = function SvgTxDotsExtra(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tx-dots-extra",
    d: "M5.059 8c1.137 0 2.059.895 2.059 2s-.922 2-2.06 2C3.923 12 3 11.105 3 10s.922-2 2.059-2zM10 8c1.137 0 2.059.895 2.059 2s-.922 2-2.059 2-2.059-.895-2.059-2S8.863 8 10 8zm4.941 0C16.078 8 17 8.895 17 10s-.922 2-2.059 2-2.059-.895-2.059-2 .922-2 2.06-2zM5.06 9.2a.812.812 0 00-.824.8c0 .442.369.8.824.8a.812.812 0 00.823-.8c0-.442-.368-.8-.823-.8zm4.94 0a.812.812 0 00-.824.8c0 .442.37.8.824.8a.812.812 0 00.824-.8c0-.442-.37-.8-.824-.8zm4.941 0a.812.812 0 00-.823.8c0 .442.368.8.823.8a.812.812 0 00.824-.8c0-.442-.369-.8-.824-.8z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#333",
    fillRule: "nonzero",
    transform: "rotate(90 10 10)",
    xlinkHref: "#tx-dots-extra"
  })));
};
export default SvgTxDotsExtra;